<template>
    <div class="booking-breakdown_block">
        <h2 class="breakdown-title">{{ $t("Holiday Breakdown") }}</h2>

        <div id="running_total">
            <table border="0" class="table">

                <tbody>
                    <tr>
                        <td colspan="2" align="center">
                            {{ $t("Dates") }}: <strong> {{getBookingDates}}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t("Accommodation") }} <span v-if="getBookingDetails.accommodation">({{getBookingDetails.accommodation}})</span></td>
                        <td align="right">{{getCurrency.symbol}}{{ getBookingDetails.accommodationPrice}} </td>
                    </tr>
                    <tr>
                        <td>{{ $t("Hire items") }}</td>
                        <td align="right">{{getCurrency.symbol}}{{ getBookingDetails.hire_items_price}} </td>
                    </tr>
                    <!-- 
                        <tr> <td>Damage Waiver  </td> <td align="right">.00</td> </tr> 
                        <tr> <td>Travel</td> <td align="right">{{getCurrency.symbol}}xxxx </td> </tr>
                    -->
                    <tr v-if="getTransportDiscount!=0">
                        <td>{{ $t("Transport Discounts") }}</td>
                        <td align="right">{{getTransportDiscount}} </td>
                    </tr>
                    <!-- <tr> <td>Insurance</td> <td align="right"></td> </tr> -->
                    <tr>
                        <td>{{ $t("Savings and Discounts") }}</td>
                        <td align="right">{{ $t("TBC") }}</td>
                    </tr>
                </tbody>
            </table>



        </div>


        <h2 class="breakdown-footer"><span>{{ $t("Total") }}</span><span>{{getCurrency.symbol}}{{ getTotalPrice}} </span></h2>
    </div>
    <div>
        <!-- <pre> {{ getBookingDetails }} </pre>  -->
        <!-- <pre> {{ getBookingDetails.transport_discount }} </pre>  -->
        <!-- <pre> {{ getBookingDetails.insurance }} </pre>  -->
        <!-- <pre> {{ getBookingDetails.additional_lines }} </pre>  -->
        <span style="color:#00b8d3"> - - - </span>
        <pre>{{getDebug}}</pre>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters([
            'getBookingDetails',
            'getCurrency',
            'getProgressStep',
        ]),        
        getDebug() {
            if(process.env.VUE_APP_DEBUG==1) {
                return this.getBookingDetails;
                // return this.getProgressStep;
            }
            return '';
        },
        getTotalPrice() {
            return parseInt(this.getBookingDetails.transport_discount)+parseInt(this.getBookingDetails.hire_items_price)+parseInt(this.getBookingDetails.accommodationPrice);
        },
        getTransportDiscount(){
            let value=this.getBookingDetails.transport_discount;
            return (value==0)?0:"-"+this.getCurrency.symbol +Math.abs(value);
        },
        getBookingDates(){
            const d1=this.getBookingDetails.BookedArrivalDate;
            const d2=this.getBookingDetails.BookedDeptDate;
            if((d1!==null)&&(d2!==null)) {
                return this.ISO2Uk(d1)+' - '+this.ISO2Uk(d2);
            } else {
                return '';
            }
        },        
    },
    methods: {
        ISO2Uk(d) {
            return d.split('-')[2]+'/'+(d.split('-')[1])+'/'+ d.split('-')[0];
        },
    }
};
</script>

<style scoped>
    table tr {
        background-color:#00B8D3;
    }
    @media (max-width: 1023px) {
        .booking-breakdown_block {
            display: none;
        }
    }
</style>
